'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    height: auto;\n  '], ['\n    height: auto;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 25px 20px;\n    > div {\n      flex-direction: column;\n      margin-bottom: 25px;\n    }\n  '], ['\n    padding: 25px 20px;\n    > div {\n      flex-direction: column;\n      margin-bottom: 25px;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-bottom: 10px;\n  '], ['\n    margin-bottom: 10px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    width: 100%;\n    margin-left: 0;\n    margin-top: 15px;\n    height: auto;\n  '], ['\n    width: 100%;\n    margin-left: 0;\n    margin-top: 15px;\n    height: auto;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _PriceDisplay = require('../common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _ProductList = require('./ProductList');

var _ProductList2 = _interopRequireDefault(_ProductList);

var _Terms = require('self-service-api/constants/Terms');

var _SuiteTileCTAsContainer = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteTileCTAsContainer');

var _SuiteTileCTAsContainer2 = _interopRequireDefault(_SuiteTileCTAsContainer);

var _SuiteViewAllFeatures = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteViewAllFeatures');

var _SuiteViewAllFeatures2 = _interopRequireDefault(_SuiteViewAllFeatures);

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _SpinnerLoadWrapper = require('../../components/loading/SpinnerLoadWrapper');

var _SpinnerLoadWrapper2 = _interopRequireDefault(_SpinnerLoadWrapper);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _Hubs = require('self-service-api/constants/Hubs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Tile = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteTile__Tile'
})(['width:100%;max-width:1100px;height:337px;border-radius:0;border:1px solid ', ';padding:65px 60px;background:', ';&:not(:last-child){margin-bottom:32px;}', ';', ';'], _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints2.default.tabletPortrait(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2));

var Title = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteTile__Title'
})(['font-size:26px;margin-bottom:10px;']);

var SubTitle = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteTile__SubTitle'
})(['font-size:16px;font-weight:normal;']);

var Price = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteTile__Price'
})(['font-size:36px;color:', ';margin-right:15px;'], _colors.OZ);

var PriceHeader = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteTile__PriceHeader'
})(['font-size:12px;color:', ';margin-bottom:5px;'], _colors.EERIE);

var PerMonth = _styledComponents2.default.span.withConfig({
  displayName: 'GrowthSuiteTile__PerMonth'
})(['font-size:18px;']);

var CrossedOutPrice = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'GrowthSuiteTile__CrossedOutPrice'
})(['color:', ';font-size:16px;line-height:27px;text-decoration:line-through;'], _colors.PANTERA);

var StyledCTAsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteTile__StyledCTAsContainer'
})(['margin-bottom:-10px;margin-left:10px;width:200px;text-align:center;button,a{width:100%;line-height:23px;}height:100px;', ' ', ';'], _responsiveBreakpoints2.default.tablet(_templateObject3), _responsiveBreakpoints2.default.phone(_templateObject4));

var GrowthSuiteTile = function GrowthSuiteTile(_ref) {
  var edition = _ref.edition,
      currencyCode = _ref.currencyCode,
      pricingDependencies = _ref.pricingDependencies,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  var defaultTerm = _GrowthSuiteEditionTermIdMap2.default[edition][_Terms.MONTHLY] || _GrowthSuiteEditionTermIdMap2.default[edition][_Terms.ANNUAL];

  var pricingInfo = void 0;
  if (purchaseMotionRequestStatus === _RequestStatusTypes2.default.SUCCEEDED) {
    pricingInfo = (0, _pricingUtils.calculateBundlePrice)({
      marketingPlanSelected: _SuiteEditionMerchIdMap2.default[edition][_Hubs.HUB_MARKETING],
      salesPlanSelected: _SuiteEditionMerchIdMap2.default[edition][_Hubs.HUB_SALES],
      servicePlanSelected: _SuiteEditionMerchIdMap2.default[edition][_Hubs.HUB_SERVICE],
      term: defaultTerm,
      pricingDependencies: pricingDependencies,
      isGrowthSuite: true
    });
  }

  return _react2.default.createElement(
    Tile,
    null,
    _react2.default.createElement(
      _SpinnerLoadWrapper2.default,
      {
        isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED
      },
      _react2.default.createElement(
        _UIFlex2.default,
        null,
        _react2.default.createElement(
          _UIBox2.default,
          { grow: 1 },
          _react2.default.createElement(
            Title,
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
              message: 'pricingPage.pages.growthSuite.title.' + edition + '_html'
            })
          ),
          _react2.default.createElement(
            SubTitle,
            null,
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'pricingPage.pages.growthSuite.discount.' + edition,
              options: {
                percent: 25
              }
            })
          )
        ),
        _react2.default.createElement(
          StyledCTAsContainer,
          null,
          _react2.default.createElement(_SuiteTileCTAsContainer2.default, { edition: edition }),
          _react2.default.createElement(
            'div',
            { className: 'm-top-4' },
            _react2.default.createElement(_SuiteViewAllFeatures2.default, {
              className: 'm-top-4',
              edition: edition,
              currencyCode: currencyCode
            })
          )
        )
      ),
      _react2.default.createElement(
        PriceHeader,
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.startsAt' })
      ),
      _react2.default.createElement(
        _UIFlex2.default,
        { className: 'm-bottom-6', align: 'baseline' },
        _react2.default.createElement(
          Price,
          null,
          _react2.default.createElement(_PriceDisplay2.default, {
            price: pricingInfo && pricingInfo.monthly.calculatedPrice,
            currencyCode: currencyCode
          }),
          _react2.default.createElement(
            PerMonth,
            null,
            _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.perMonth' })
          )
        ),
        _react2.default.createElement(CrossedOutPrice, {
          price: pricingInfo && pricingInfo.monthly.fullPrice,
          currencyCode: currencyCode
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { fontWeight: 600 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.includes' })
        ),
        _react2.default.createElement(_ProductList2.default, { edition: edition })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteTile);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/GrowthSuiteTile.js
// module id = 772
// module chunks = 3 4